import styled from "styled-components";

export const ReplaceInput = styled.div<{ placeholder: string }>`
  [contenteditable="true"]:empty:before {
    content: attr(placeholder);
  }
`;
